module.exports = __webpack_public_path__ + "static/media/hero_desktop.c3b53033.webp";